if (document.getElementById('page-favList')) {
  pageFavList()
}

function pageFavList() {
  //   ####            #####    #####   ####  #####  ######
  //  ##               ##  ##   ##     ##     ##       ##
  //  ##     ########  #####    #####   ###   #####    ##
  //  ##               ##  ##   ##        ##  ##       ##
  //   ####            ##   ##  #####  ####   #####    ##
  // チェックボックスをリセットする
  /*
<button type="button" class="js-checkReset" data-check-reset="favDel"></button>
<input type="checkbox" name="" value="" class="js-checkReset--favDel">
  */

  window.addEventListener('click', function (e) {
    if (!e.target.closest('.js-checkReset')) {
      return
    }
    const targetList = document.getElementsByClassName('js-checkReset--' + e.target.dataset.checkReset)
    for (const iterator of targetList) {
      iterator.checked = false
    }
  })
}
